import type { QueryParams } from "@imminently/react/store/query";
import { ClinicalRisk, Frailty } from "@/resources/types";
import qs from "query-string";

export type PatientListView = {
  name: string;
  query: QueryParams;
};

const { stringify } = qs;
const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;

export const PATIENT_LIST_VIEWS: PatientListView[] = [
  {
    name: "Expects",
    query: {
      status: ["expected"],
    } as QueryParams,
  },
  {
    name: "High risk",
    query: {
      "riskScore.risk": `$gte=${ClinicalRisk.MEDIUM}`,
      status: ["submitted", "triaged", "seen"],
    } as QueryParams,
  },
  {
    name: "LOS > 12h",
    query: {
      arrived: `$lt=${Date.now() - TWELVE_HOURS_MS }`,
      status: ["submitted", "triaged", "seen", "admitted", "consult", "transferred"],
    } as QueryParams,
  },
  {
    name: "Infectious",
    query: {
      infectiousSymptoms: { $notDefined: false },
    } as QueryParams,
  },
  {
    name: "Older patients",
    query: (() => {
      const currentYear = new Date().getFullYear();
      const minAge = 75;
      const maxAge = 120;
      const youngestYear = currentYear - minAge;
      const oldestYear = currentYear - maxAge;
      const start = new Date(String(oldestYear)).getTime();
      const end = new Date(String(youngestYear)).getTime();

      return {
        patient_dob: [stringify({ $r: `${start},${end}` })],
      } as QueryParams;
    })(),
  },
];

